var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { utils as dataUtils } from '@easydata/core';
import { Widget, WidgetGroup, QueryChangeAction } from '@easyquery/core';
import { slideUp, slideDown, domel } from '@easydata/ui';
import { QueryPanel } from './query_panel';
import { browserUtils } from '../utils/browser_utils';
var FilterBar = /** @class */ (function (_super) {
    __extends(FilterBar, _super);
    function FilterBar(slot) {
        var _this = _super.call(this, slot) || this;
        _this.options = {
            applyOnClose: true,
            showApplyButton: true,
            showClearButton: true,
            queryPanel: {
                showAddRow: true,
                showCheckboxes: true,
                alwaysShowButtonsInGroups: true
            }
        };
        _this.headerClickListener = _this.headerClickHandler.bind(_this);
        _this.group = WidgetGroup.Query;
        return _this;
    }
    FilterBar.prototype.getWidgetType = function () {
        return 'filterBar';
    };
    Object.defineProperty(FilterBar.prototype, "cssPrefix", {
        get: function () {
            return 'eqjs-fb';
        },
        enumerable: true,
        configurable: true
    });
    FilterBar.prototype.init = function (context, options) {
        _super.prototype.init.call(this, context, options);
        this.setOptions(options);
        this.destroyCore();
        this.qpElement = domel('div')
            .addClass(this.cssPrefix + "-querypanel")
            .toDOM();
        this.queryPanel = new QueryPanel(this.qpElement);
        this.queryPanel.init(context, this.options.queryPanel || {});
        this.attachQueryObserver();
    };
    FilterBar.prototype.setOptions = function (options) {
        this.options = dataUtils.assignDeep(this.options, options);
    };
    FilterBar.prototype.applyBtnClick = function (ev) {
        this.applyFilter();
    };
    FilterBar.prototype.clearBtnClick = function (ev) {
        this.clearFilter();
    };
    FilterBar.prototype.showQueryPanel = function (callback) {
        var _this = this;
        slideDown(this.qpBlock, 200, function () {
            _this.updateHeader();
            if (callback)
                callback();
        });
    };
    FilterBar.prototype.hideQueryPanel = function () {
        var _this = this;
        slideUp(this.qpBlock, 200, function () {
            _this.updateHeader();
            if (_this.options.applyOnClose) {
                _this.applyFilter();
            }
        });
    };
    FilterBar.prototype.headerClickHandler = function (ev) {
        ev.preventDefault();
        if (domel(this.qpBlock).isVisible()) { // close query panel
            this.hideQueryPanel();
        }
        else { //open query panel
            this.showQueryPanel();
        }
    };
    FilterBar.prototype.updateHeader = function () {
        if (!this.headerTextElement)
            return;
        var text = '';
        var query = this.getContext().getQuery();
        if (query) {
            text = query.getConditionsText();
        }
        if (text == '') {
            text = i18n.getText('StrNoFilterDefined');
        }
        domel(this.headerTextElement)
            .text(text)
            .attr('title', text);
        if (!query || query.isEmptyConditions()) { //empty query, don't show query panel and arrow, show link in header
            domel(this.headerTextElement).hide();
            domel(this.headerLinkElement).show();
            if (!domel(this.qpBlock).isVisible()) {
                domel(this.headerArrowBlock).hide();
                this.headerElement.style.cursor = '';
                this.headerElement.removeEventListener('click', this.headerClickListener);
            }
        }
        else {
            this.headerElement.style.cursor = 'pointer';
            this.headerElement.removeEventListener('click', this.headerClickListener);
            this.headerElement.addEventListener('click', this.headerClickListener);
            domel(this.headerTextElement).show();
            domel(this.headerLinkElement).hide();
            domel(this.headerArrowBlock).show();
        }
        if (domel(this.qpBlock).isVisible()) { // close query panel
            this.headerArrowElement.classList.add(this.cssPrefix + "-header-arrowUp");
        }
        else {
            this.headerArrowElement.classList.remove(this.cssPrefix + "-header-arrowUp");
        }
        this.textResize();
    };
    FilterBar.prototype.render = function () {
        var _this = this;
        domel(this.slot)
            .addClass(this.cssPrefix + "-container")
            .addClass(browserUtils.getMobileCssClass())
            .addChild('div', function (builder) { return _this.headerElement = builder
            .addClass(_this.cssPrefix + "-header")
            .addChild('div', function (builder) { return _this.headerIconElement = builder
            .addClass(_this.cssPrefix + "-header-icon")
            .toDOM(); })
            .addChild('div', function (builder) { return _this.headerTextBlock = builder
            .addClass(_this.cssPrefix + "-header-textblock")
            .addChild('div', function (builder) { return _this.headerTextElement = builder
            .addClass(_this.cssPrefix + "-header-text")
            .toDOM(); })
            .addChild('div', function (builder) { return _this.headerLinkElement = builder
            .addClass(_this.cssPrefix + "-header-text " + _this.cssPrefix + "-header-link")
            .text(i18n.getText('StrNoFilterClickToAdd'))
            .hide()
            .on('click', function () {
            _this.queryPanel.showEntitiesMenu({
                anchor: _this.headerLinkElement,
                selectedIds: null,
                itemSelectedCallback: function (item, items) {
                    var attrid = item.id;
                    _this.showQueryPanel(function () {
                        var query = _this.getContext().getQuery();
                        var descr = {
                            parent: query.getRootCondition(),
                            attributeId: attrid
                        };
                        var cond = query.addSimpleCondition(descr);
                        if (cond) {
                            query.fireConditionsChangedEvent(QueryChangeAction.Add, cond);
                        }
                    });
                }
            });
        })
            .toDOM(); })
            .toDOM(); })
            .addChild('div', function (builder) { return _this.headerArrowBlock = builder
            .addClass(_this.cssPrefix + "-header-arrowblock")
            .addChild('div', function (builder) { return _this.headerArrowElement = builder
            .addClass(_this.cssPrefix + "-header-arrow")
            .toDOM(); })
            .toDOM(); })
            .toDOM(); })
            .addChild('div', function (builder) { return _this.qpBlock = builder
            .addClass(_this.cssPrefix + "-querypanelblock")
            .addClass(browserUtils.getMobileCssClass())
            .hide()
            .addChildElement(_this.qpElement)
            .toDOM(); });
        if (this.options.showApplyButton || this.options.showClearButton) {
            this.buttonsBlock = domel('div', this.qpBlock)
                .addClass(this.cssPrefix + "-buttonsblock")
                .addClass(browserUtils.getMobileCssClass())
                .toDOM();
        }
        if (this.options.showApplyButton) {
            domel('a', this.buttonsBlock)
                .attr('href', 'javascript:void(0)')
                .addClass(this.cssPrefix + "-button " + this.cssPrefix + "-button-apply")
                .text(i18n.getText('ButtonApply'))
                .on('click', this.applyBtnClick.bind(this));
        }
        if (this.options.showClearButton) {
            domel('a', this.buttonsBlock)
                .attr('href', 'javascript:void(0)')
                .addClass(this.cssPrefix + "-button " + this.cssPrefix + "-button-clear")
                .text(i18n.getText('CmdClear'))
                .on('click', this.clearBtnClick.bind(this));
        }
        window.addEventListener('resize', function () {
            _this.textResize();
        });
        this.updateHeader();
        this.queryPanel.refresh();
        setTimeout(function () { return _this.textResize(); }, 500);
    };
    FilterBar.prototype.refreshCore = function () {
        this.clear();
        this.render();
    };
    FilterBar.prototype.clear = function () {
        this.slot.innerHTML = "";
    };
    FilterBar.prototype.applyFilter = function () {
        if (this.options.applyFilterCallback) {
            this.options.applyFilterCallback();
        }
    };
    FilterBar.prototype.clearFilter = function () {
        var query = this.getContext().getQuery();
        if (query) {
            query.clearConditions();
            query.fireConditionsChangedEvent(QueryChangeAction.All);
        }
    };
    FilterBar.prototype.textResize = function () {
        this.headerTextBlock.style.width = (this.slot.clientWidth - this.headerIconElement.offsetWidth
            - (domel(this.headerArrowBlock).isVisible() ? this.headerArrowBlock.offsetWidth : 0)) + "px";
    };
    FilterBar.prototype.destroyCore = function () {
        if (this.queryPanel)
            this.queryPanel.destroy();
        this.detachQueryObserver();
        this.slot.innerHTML = '';
    };
    FilterBar.prototype.attachQueryObserver = function () {
        var _this = this;
        var query = this.getContext().getQuery();
        this.queryEventCallbackId = query.addChangedCallback(function (event) {
            _this.updateHeader();
        });
    };
    FilterBar.prototype.detachQueryObserver = function () {
        var query = this.getContext().getQuery();
        if (query)
            query.removeChangedCallback(this.queryEventCallbackId);
    };
    return FilterBar;
}(Widget));
export { FilterBar };
//# sourceMappingURL=filter_bar.js.map